import { render, staticRenderFns } from "./power-list.vue?vue&type=template&id=7dcc7ec6&scoped=true&"
import script from "./power-list.vue?vue&type=script&lang=js&"
export * from "./power-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc7ec6",
  null
  
)

export default component.exports